export enum ArtefactType {
  dataset = "dataset",
  model = "model",
  usecase = "usecase",
  toolkit = "toolkit",
  article = "article",
}
